/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class CompanyViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log,
        companyService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.companyService = companyService;
        this.$log.debug('Controller \'CompanyView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.company.update';
            initPromise = this.companyService.getEntity(this.$stateParams.id);
        } else {
            this.updateMode = false;
            this.title = 'ui.company.creation';
            initPromise = this.$q.resolve();
        }

        this.handleRestServiceCall(initPromise, entity => {
            this.pristineEntity = entity;
            this.reset();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.companyService.updateEntity(this.company);
        } else {
            serviceActionPromise = this.companyService.createEntity(this.company);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.company.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.organization.company.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.company = angular.copy(this.pristineEntity);
    }
}

export const companyViewComponent = {
    template: require('./company-view.html'),
    controller: CompanyViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/CompanyView.js